module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-koh.6c6b2884.jpg";